import { B as u } from "./buffer-DIFxvF2Q.js";
class o extends u {
  recordGauge(r) {
    return this._bufferCall("recordGauge", [r]);
  }
  recordCount(r) {
    return this._bufferCall("recordCount", [r]);
  }
  recordIncr(r) {
    return this._bufferCall("recordIncr", [r]);
  }
  recordHistogram(r) {
    return this._bufferCall("recordHistogram", [r]);
  }
  recordUpDownCounter(r) {
    return this._bufferCall("recordUpDownCounter", [r]);
  }
  startSpan(r, e, t, l) {
    return this._bufferCall("startSpan", [r, e, t, l]);
  }
  startManualSpan(r, e, t, l) {
    return this._bufferCall("startManualSpan", [r, e, t, l]);
  }
  register(r, e) {
    return this._bufferCall("register", [r, e]);
  }
  recordLog(r, e, t) {
    return this._bufferCall("recordLog", [r, e, t]);
  }
  recordError(r, e, t, l, a) {
    return this._bufferCall("recordError", [
      r,
      e,
      t,
      l,
      a
    ]);
  }
}
let s;
typeof globalThis != "undefined" ? globalThis.LDObserve ? s = globalThis.LDObserve : (s = new o(), globalThis.LDObserve = s) : s = new o();
export {
  s as LDObserve
};
//# sourceMappingURL=LDObserve.js.map
